// extracted by mini-css-extract-plugin
export default {"Columns":"Columns_Columns__+L9Ao","buttonColumn":"Columns_buttonColumn__wrV2L"};